import React from 'react';
import { createUseStyles, clsx } from '@pushpay/styles';
const useStyles = createUseStyles({
  root: ({
    animationDuration,
    animationDelay
  }) => ({
    position: 'relative',
    height: '1.25em',
    width: '1.25em',
    backgroundColor: 'transparent',
    transform: 'rotateZ(-45deg)',
    '&:before, &:after': {
      content: '""',
      height: '4px',
      width: '4px',
      position: 'absolute',
      left: 0,
      backgroundColor: 'currentColor',
      transform: 'translateY(-10px)'
    },
    '&:before': {
      height: 0,
      top: '50%',
      animation: `${animationDuration / 2}ms ease-out ${animationDelay}ms forwards $tickHorizontal`
    },
    '&:after': {
      width: 0,
      bottom: 0,
      animation: `${animationDuration / 2}ms ease-out ${animationDelay + animationDuration / 2}ms forwards $tickVertical`
    }
  }),
  '@keyframes tickHorizontal': {
    '0%': {
      height: 0
    },
    '100%': {
      height: '40%'
    }
  },
  '@keyframes tickVertical': {
    '0%': {
      width: 0
    },
    '100%': {
      width: '80%'
    }
  }
});

const AnimatedTickIcon = ({
  animationDuration = 300,
  animationDelay = 350,
  classes: classesProp,
  className: classNameProp
}) => {
  const classes = useStyles(classesProp, {
    animationDuration,
    animationDelay
  });
  const className = clsx(classNameProp, classes.root);
  return /*#__PURE__*/React.createElement("div", {
    className: className
  });
};

export default AnimatedTickIcon;